import { useEffect, useRef } from 'react';
import Snackbar from 'node-snackbar';
import 'node-snackbar/dist/snackbar.min.css';
import u from 'umbrellajs';
import { rgbToHex } from '@material-ui/core/styles/colorManipulator';
import _e from 'common/localeUtil';
import {
	addChildComponentsGrapesJS,
	checkWindowVariableChangedToTrue,
	findGrapesJSComponents,
	findGrapesJSComponent,
	searchNodeTreeByTextContent,
	getContentGrapesJSComponent,
	getElementFromIframe,
	getWidgetsFromHTML,
	setAllChildComponentsReadOnly,
	setContentGrapesJSComponent,
	setHrefGrapesJSComponent,
	setStyleGrapesJSComponents,
	showHideTopMenu,
	setAllComponentsReadOnlyButTextAndImage,
	applyTextIntoSelector,
	removeAddClassElement,
	setAttributeGrapesJSComponent,
	hideGrapesJSComponents,
	showGrapesJSComponents,
	getAttributeGrapesJSComponent,
} from './domUtils';

import {
	ALL_WIDGETS,
	BRANDING_TYPE,
	CONTACT_DISCLAIMER_DEFAULT,
	WIDGET_DISCLAIMER_DEFAULT,
} from '../constants';
import { htmlSerializer, migrateSlateDataIfNeeded } from './editor/editorUtils';
import TemplateConfigs from '../configs/templates';

const AGENT_API_ROOT = `${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/`;
const PUBLISH_TEMPLATE_URL = `${AGENT_API_ROOT}publish_template/`;
const UNPUBLISH_TEMPLATE_URL = `${AGENT_API_ROOT}unpublish_template/`;
export const loadTemplateURL = `${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/load_template_details/`;

export const isEmpty = (obj) => {
	return Object.keys(obj).length === 0;
};

export const getTemplateType = (templateId) => {
	if (templateId.includes('report')) {
		return BRANDING_TYPE.TYPE_REPORT_COVER;
	}
	if (templateId.includes('ebookintro')) {
		return BRANDING_TYPE.TYPE_EBOOK_INTRO;
	}
	return BRANDING_TYPE.TYPE_WEBSITE;
};

export const getEntityWebsiteReportEbook = (coverMode = false) => {
	let entity;
	if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_REPORT_COVER) {
		if (coverMode) {
			entity = _e('report_cover', { capitalize: true });
		} else {
			entity = _e('report');
		}
	} else if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_EBOOK_INTRO) {
		if (coverMode) {
			entity = _e('ebook_intro', { capitalize: true });
		} else {
			entity = _e('ebook_intro');
		}
	} else {
		if (coverMode) {
			entity = _e('website', { capitalize: true });
		} else {
			entity = _e('website');
		}
	}
	return entity;
};

export const getDefaultTitleForSections = (id, title) => {
	// console.log('getDefaultTitleForSections', id, title);
	if (title) return title;

	let defaultTitle = '';
	if (id.includes('-about')) {
		defaultTitle = _e('my_story');
	} else if (id.includes('-services')) {
		defaultTitle = _e('my_services');
	} else if (id.includes('-accolades')) {
		defaultTitle = _e('my_achievements');
	} else if (id.includes('-videos')) {
		defaultTitle = _e('videos');
	} else if (id.includes('-testimonials')) {
		defaultTitle = _e('testimonials');
	} else if (id.includes('-calculator')) {
		defaultTitle = _e('tools');
	} else if (id.includes('-contact')) {
		defaultTitle = _e('contact');
	} else if (id.includes('-ebook')) {
		defaultTitle = _e('ebook');
	} else if (id.includes('-dummy1')) {
		defaultTitle = `${_e('background')} 1`;
	} else if (id.includes('-dummy2')) {
		defaultTitle = `${_e('background')} 2`;
	}
	return defaultTitle;
};

export const random = () => {
	return (
		Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
	);
};

const getQueryVariable = (variable) => {
	const query = window.location.search.substring(1);
	const vars = query.split('&');
	for (let i = 0; i < vars.length; i += 1) {
		const pair = vars[i].split('=');
		if (pair[0] === variable) {
			return pair[1];
		}
	}
	return null;
};

export const getTemplate = () => {
	const queryVar = getQueryVariable('template') || '';
	return queryVar;
};

export const getPMLink = () => {
	const queryVar = getQueryVariable('pmlink') || '';
	return queryVar;
};

export const getIsPB = () => {
	const queryVar = getQueryVariable('isPB') || '';
	return queryVar;
};

export const doGet = (url) => {
	return fetch(url)
		.then((data) => data.text())
		.then((data) => {
			return data;
		})
		.catch((err) => {
			console.error(err);
			return '';
		});
};

export const doPost = (url, data) => {
	// const headers = new Headers();
	// headers.append('X-CSRFToken', 'something');
	return fetch(url, {
		method: 'post',
		credentials: 'include', // Important to include cookies
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})
		.then((response) => {
			// console.log('doPost response', response);
			if (response.status === 200) {
				return response.json();
			}
			return {
				error: response.statusText,
			};
		})
		.then((_data) => {
			return _data;
		})
		.catch((err) => {
			console.log('doPost err', err);
		});
};

export const loadTemplate = (options) => {
	const templateOptions = options || window;
	return doPost(loadTemplateURL, {
		// token: options.userToken,
		draft: true,
		branding_type: templateOptions.GM_BRANDING_TYPE,
		template: templateOptions.selectedTemplate,
	});
};

// export const loadTemplateMeta = (token, templateName) => {
// 	return doPost(loadTemplateURL, {
// 		// token,
// 		draft: false,
// 		template: templateName
// 	});
// };

export const getFullEditingStatus = (character) => {
	const websiteStatuses = {
		P: _e('published'),
		D: 'Draft',
		B: _e('blank'),
	};

	return websiteStatuses[character];
};

// Re-exported from the date-library wrapper so existing importers keep working.
export { formatDefaultDateTime } from './dateUtil';

export const addJSToTemplate = () => {
	// console.log('In addJSToTemplate reportKyc reportGM', reportKyc, reportGM);
	if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_REPORT_COVER) {
		const scriptEl = document.createElement('script');
		scriptEl.src = '/js/main-template-report.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);
	} else if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_WEBSITE) {
		let scriptEl = document.createElement('script');
		scriptEl.src = 'https://static.goalsmapper.com/public/personal_website/lory.min.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src = 'https://static.goalsmapper.com/public/personal_website/umbrella.min.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src = 'https://static.goalsmapper.com/public/personal_website/fitty.min.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src = '/js/okay-nav.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src = 'https://static.goalsmapper.com/public/personal_website/es5.min.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src = '/js/main-compiled.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src =
			'https://static.goalsmapper.com/public/personal_website/react.production.min.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);

		scriptEl = document.createElement('script');
		scriptEl.src =
			'https://static.goalsmapper.com/public/personal_website/react-dom.production.min.js';
		window.grapesjs.Canvas.getDocument().body.appendChild(scriptEl);
	}
};

export const showSuccessMessage = (text) => {
	Snackbar.show({
		text,
		pos: 'top-right',
		showAction: false,
		backgroundColor: '#fff', // 215BAB   B38630
		textColor: '#000',
	});
};

export const showFailedMessage = (text) => {
	Snackbar.show({
		text,
		pos: 'top-right',
		showAction: false,
		backgroundColor: '#AC0C00', // 215BAB   B38630
		textColor: '#fff',
	});
};

export const showSnackbar = (options) => {
	Snackbar.show(options);
};

const getStyleFullScreenBackground = () => {
	let overrideBackgroundImageUrl = '';
	if (window.GM_BACKGROUND_IMAGE_URL) {
		overrideBackgroundImageUrl = `
            .full-screen {
              background-image: url("${window.GM_BACKGROUND_IMAGE_URL}");
            }
    `;
	}
	return overrideBackgroundImageUrl;
};

export const createVariablesInDocument = () => {
	const element = document.createElement('style');
	element.innerHTML = getStyleFullScreenBackground();
	// console.log('createVariablesInDocument', element.innerHTML);
	window.grapesjs.Canvas.getDocument().body.appendChild(element);

	// jarallax again
	// const newScript = document.createElement('script');
	// const inlineScript = document.createTextNode(
	// "jarallax(document.querySelectorAll('.jarallax'));");
	// newScript.appendChild(inlineScript);
	// window.grapesjs.Canvas.getDocument().body.appendChild(newScript);
};

export const getEditorHtml = () => {
	if (!window.grapesjs) {
		return null;
	}
	const overrideBackgroundImageUrl = getStyleFullScreenBackground();
	const grapesJSCSS = window.grapesjs.getCss();

	const html = `
          ${window.grapesjs.getHtml()}
          <style>
          ${grapesJSCSS}
          </style>
          <style>
            ${overrideBackgroundImageUrl}
          </style>
		`.trim();
	return html;
};

export const getEditorContent = () => {
	if (!window.grapesjs) {
		return null;
	}
	return {
		html: window.grapesjs.getHtml(),
		css: [window.grapesjs.getCss(), getStyleFullScreenBackground()],
	};
};

export const publishTemplate = (template) => {
	return doPost(`${PUBLISH_TEMPLATE_URL}${template}/`);
};

export const unPublishTemplate = (template) => {
	return doPost(`${UNPUBLISH_TEMPLATE_URL}${template}/`);
};

const onImageClick = () => {
	// console.log('onImageClick', event.target.getAttribute('style'));
	// const imageUrl = event.target.getAttribute('style').
	const modal = window.grapesjs.Modal;
	modal.close();
};

const addEventListenerImageClick = () => {
	// add click event listener
	const allElements = document.querySelectorAll('.gjs-mdl-content .gjs-am-asset-image');
	if (allElements) {
		allElements.forEach((div) => {
			div.addEventListener('click', onImageClick);
		});
	}
};

const generatePagination = (data, searchPage = 1) => {
	let { total_pages } = data;
	// Limit to 40 pages results now
	total_pages = Math.min(total_pages, 40);
	// console.log('TCL: generatePagination total_pages', total_pages);
	if (!total_pages) {
		return;
	}
	const element = document.createTextNode('');
	// <a href="#">&laquo;</a>
	// <a href="#">&raquo;</a>

	let innerA = '';
	for (let i = 1; i <= total_pages; i += 1) {
		if (i === parseInt(searchPage, 10)) {
			innerA += `
                <a href="#" class="active" data-search-page=${i}>${i}</a>
                `;
		} else {
			innerA += `
                <a href="#">${i}</a>
                `;
		}
	}
	element.innerHTML = `
        <div class="pagination">
          ${innerA}         
        </div>
              `;
	const amAssetsElement = document.querySelector('.gjs-mdl-content .gjs-am-assets');
	amAssetsElement.insertAdjacentHTML('beforeend', element.innerHTML);
};

const cleanUpSearchResults = () => {
	// should clean up images
	const allElements = document.querySelectorAll('.gjs-mdl-content .gjs-am-asset');
	// console.log('addUnsplashSearchBox unsplashBox not null', allElements);
	if (allElements) {
		allElements.forEach((div) => {
			div.remove();
		});
	}
	const paginationElement = document.querySelector('.gjs-mdl-content .pagination');
	if (paginationElement) paginationElement.remove();
};

// Module-private handler (not re-exported): avoids a webpack-5 star-export
// collision with grapesjsOnInitEditor.js's doUnsplashSearch in the
// utils/index.js barrel. It was never imported by name anywhere.
const doUnsplashSearch = (evt) => {
	cleanUpSearchResults();

	// if (!evt) {
	//   inputSearchValue = defaultKeyword;
	// } else {
	//   inputSearchValue = document.querySelector('#input-unsplash-search').value || 'finance';
	// }
	const searchPage = evt?.target?.text || 1;
	const inputSearchValue = document.querySelector('#input-unsplash-search').value || 'finance';
	console.log('TCL: doUnsplashSearch searchPage, inputSearchValue', searchPage, inputSearchValue);

	return fetch(
		`https://api.unsplash.com/search/photos?query=${inputSearchValue}&per_page=${20}&page=${searchPage}`,
		{
			headers: {
				Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_API_KEY}`,
			},
		},
	)
		.then((response) => response.json())
		.then((data) => {
			const images = data.results;
			console.log('TCL: doUnsplashSearch data', images);

			// Add to assets manager
			const assetManager = window.grapesjs.AssetManager;
			images.forEach((imageData) => {
				assetManager.add({
					// src: imageData.urls.full,
					src: imageData.urls.regular,
					name: imageData.description || imageData.alt_description,
				});
			});
			addEventListenerImageClick();
			// const amConfig = assetManager.getConfig();
			// amConfig.onClick = function onClickDEF(model) {
			//   console.log('onClickDEF');
			// };

			// Generate Pagination
			generatePagination(data, searchPage);
			// add click event listener
			const allElements = document.querySelectorAll('.pagination a');
			if (allElements) {
				allElements.forEach((div) => {
					div.addEventListener('click', doUnsplashSearch);
				});
			}

			return images;
		})
		.catch((err) => {
			console.error(err);
			// return "";
		});
};

const addUnsplashSearchBox = () => {
	const unsplashBox = document.querySelector('#unsplash-box');
	if (!unsplashBox) {
		const element = document.createTextNode('');
		element.innerHTML = `
        <div id="unsplash-box" class="gjs-am-assets-header">
          <div class="gjs-am-add-asset">
            <div class="gjs-field gjs-am-add-field">
              <input id="input-unsplash-search" value="" placeholder="put keyword here">
              </div>
              <button id="submit-unsplash-search" class="gjs-btn-prim">Search</button>
              <div style="clear:both"></div>
            </div>
          </div>
        </div>	
              `;
		const pnButtons = document.querySelector('.gjs-am-assets-cont');
		pnButtons.insertAdjacentHTML('afterbegin', element.innerHTML);
		document
			.querySelector('#submit-unsplash-search')
			.addEventListener('click', doUnsplashSearch);
		document
			.querySelector('#submit-unsplash-search')
			.addEventListener('click', doUnsplashSearch);
		document.querySelector('#input-unsplash-search').addEventListener('keyup', (event) => {
			if (event.keyCode === 13) {
				event.preventDefault();
				document.querySelector('#submit-unsplash-search').click();
			}
		});
	}
	doUnsplashSearch(null);
};

export const onModalAssetsOpen = () => {
	addUnsplashSearchBox();
	addEventListenerImageClick();
};

// export const modifyPreviewCommand = () => {
//   const commands = window.grapesjs.Commands;
//   commands.add('preview', editor => {
//   });
// };

export const useDidUpdate = (callback, deps) => {
	const hasMount = useRef(false);

	useEffect(() => {
		if (hasMount.current) {
			callback();
		} else {
			hasMount.current = true;
		}
	}, deps);
};

export const getFontFamilyFromHTML = (selector, fallback) => {
	const cssComposer = window.grapesjs.CssComposer;
	const rule = cssComposer.getRule(selector);
	if (!rule) {
		return fallback;
	}
	const fontFamily = rule.get('style')['font-family'] || fallback;
	return fontFamily.replace(/"/g, '');

	// console.log('rule', rule.get('style'));
	// const fullCSS = window.grapesjs.getCss();

	// // console.log('getFontFamilyFromHTML fullCSS', fullCSS);
	// const index = fullCSS.indexOf(selector);
	// let fontFamily = null;
	// if (index >= 0) {
	// 	const a = fullCSS.indexOf(':', index);
	// 	const b = fullCSS.indexOf(';', index);
	// 	// fontFamilyFirst = fullCSS.substr(a + 1, b - a - 1);
	// 	fontFamily = fullCSS.substr(a + 1, b - a - 1);
	// 	fontFamily = fontFamily.replace(/"/g, '');
	// 	// console.log('getFontFamilyFromHTML', fontFamily, a, b);
	// }
	// return fontFamily;
};

export const setContactFormToTemplate = (values) => {
	// console.log('setContactFormToTemplate', values);
	if (!values) {
		return;
	}
	checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
		// console.log(
		// 	'setContactFormToTemplate checkWindowVariableChangedToTrue',
		// 	values
		// );
		setTimeout(() => {
			setContentGrapesJSComponent('.info-above-email', values.receiving_email);
			setContentGrapesJSComponent('.realemail', values.receiving_email);
			setHrefGrapesJSComponent('a.facebook', values.facebook);
			setHrefGrapesJSComponent('a.twitter', values.twitter);
			setHrefGrapesJSComponent('a.linkedin', values.linkedin);
			setHrefGrapesJSComponent('a.instagram', values.instagram);
			setHrefGrapesJSComponent('a.whatsapp', values.whatsapp);
			setHrefGrapesJSComponent('a.telegram', values.telegram);

			let submitButtonText = _e('submit');
			if (window.selectedTemplate === 'template11') {
				submitButtonText = _e('contact_me');
			}
			setContentGrapesJSComponent(
				'#section-contact .button',
				values.buttonText || submitButtonText,
			);
		}, 500);
	});
};

export const showFormikValues = (values, setSubmitting) => {
	setTimeout(() => {
		alert(JSON.stringify(values, null, 2));
		setSubmitting(false);
	}, 400);
};

export const usePrevious = (value) => {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};

export function getWindowSize() {
	if (window.innerWidth) {
		return {
			width: window.innerWidth,
			height: window.innerHeight,
		};
	}
	if (document.documentElement.clientWidth) {
		return {
			width: document.documentElement.clientWidth,
			height: document.documentElement.clientHeight,
		};
	}
	return window.screen;
}

export const handleClickPreviewButton = async () => {
	window.gm_track(`Preview Button Clicked`);
	window.open(
		`${process.env.REACT_APP_PREVIEW_URL}/?template=${window.selectedTemplate}`,
		'GM_AGENT_PREVIEW_WEBSITE',
	);
};

export const getTemplateHTML = (templateName) => {
	if (templateName.includes('report')) {
		return doGet(`/report_templates/${templateName}.html`);
	}
	if (templateName.includes('ebookintro')) {
		return doGet(`/ebookintro_templates/${templateName}.html`);
	}
	return doGet(`/website_templates/${templateName}.html`);
};

export const getFullSubdomainURL = (subdomain) => {
	return `https://${subdomain}.${process.env.REACT_APP_SITE_URL}`;
};

export const saveInfoToLocalStorage = (template, isPB, pmLink) => {
	if (localStorage.getItem('template')) {
		localStorage.removeItem('template');
	}
	sessionStorage.setItem('template', template);
	// localStorage.setItem('token', token);
	localStorage.setItem('isPB', isPB);
	localStorage.setItem('pmLink', pmLink);
};

export const generateUrlFromLocalStorage = (fromTemplate) => {
	let template = fromTemplate;
	if (!template) {
		template = sessionStorage.getItem('template');
	}
	const isPB = localStorage.getItem('isPB');
	const pmLink = localStorage.getItem('pmLink');
	return `${document.location.origin}/html-builder/?template=${template}&isPB=${isPB}&pmLink=${pmLink}`;
};

export const getWidgetURL = (widget) => {
	const defaultAdviserData = { id: 152, country: 'SG', full_name: 'Lisa Tan' };
	const { id, country, full_name = '' } = window.adviserData || defaultAdviserData;
	let realWidgetBaseUrl;
	if (
		window.location.hostname.includes('localhost') ||
		window.location.hostname.includes('goalsmapper.test') ||
		window.location.hostname.includes('customise-new')
	) {
		realWidgetBaseUrl = widget.widgetUrlStage;
	} else {
		realWidgetBaseUrl = widget.widgetUrl;
	}
	realWidgetBaseUrl = `${realWidgetBaseUrl}?agent-id=${id}&country=${country}&agent-name=${full_name}`;
	return realWidgetBaseUrl;
};

export const stripTagsFromHTML2 = (html) => {
	// Create a new div element
	const temporalDivElement = document.createElement('div');
	// Set the HTML content with the providen
	temporalDivElement.innerHTML = html;
	// Retrieve the text property of the element (cross-browser support)
	return temporalDivElement.textContent || temporalDivElement.innerText || '';
};

export const getTitleFromSection = (sectionId) => {
	let titleHTML = getContentGrapesJSComponent(`${sectionId} .header`);
	titleHTML = stripTagsFromHTML2(titleHTML);
	titleHTML = getDefaultTitleForSections(sectionId, titleHTML);
	// console.log('getTitleFromSection', sectionId, titleHTML);
	return titleHTML;
};

const generateEachWidgetHTML = (widgetId, layoutCol) => {
	const widget = ALL_WIDGETS().find((widget_) => widget_.id === widgetId);

	const realWidgetBaseUrl = getWidgetURL(widget);
	let col = '';
	if (layoutCol === 2) {
		col = 'is-half';
	} else if (layoutCol === 3) {
		col = 'is-one-third';
	} else if (layoutCol === 4) {
		col = 'is-one-quarter';
	} else if (layoutCol === 5) {
		col = 'is-one-fifth';
	}

	// <a href="${realWidgetBaseUrl}" target="_blank">Begin</a>
	return `<div class="column each-section widget-item-wrapper ${col}" id="${widget.id}" title="${
		widget.title
	}">
        <div class="each-section-image"><img src="${widget.image}"></div>
        <div class="each-section-title" data-gjs-type="text">${widget.title}</div>
        <div class="each-section-subtitle" data-gjs-type="text">${widget.subtitle}</div>
        <div class="each-section-button">
        	<div class="contact">
        	  	<button class="button is-link" data-url="${realWidgetBaseUrl}">${_e('begin')}</button>
          	</div>	
		</div>
      </div>`;
};

export const generateWidgetsInHTML = (widgets) => {
	let html;
	if (widgets.length === 0) {
		html = '';
	} else {
		const layoutCol = getAttributeGrapesJSComponent('#section-calculator', 'data-layout-col');
		let widgetsHTML = widgets.map((widgetId) => generateEachWidgetHTML(widgetId, layoutCol));
		console.log('generateWidgetsInHTML', widgetsHTML);
		widgetsHTML = widgetsHTML.join('');

		const calculatorTitle =
			getContentGrapesJSComponent('a[href="#section-calculator"]') ||
			_e('financial_calculator');
		const calculatorContainerClassName =
			window.currentTemplate === 'template3' ? 'containertemplate3' : 'container';
		html = `<div class="${calculatorContainerClassName}">
							<div class="calculator-title header">
								${calculatorTitle}
							</div>
						</div>  
						<div class="container">
							<div class="columns is-multiline widgets-wrapper layoutable min-1-row">
								${widgetsHTML}
							</div>
						</div>`;
	}
	addChildComponentsGrapesJS('.section-calculator-content', html);
	setAllChildComponentsReadOnly('.section-calculator-content', ['calculator-title']);
};

export const convertSlateToHTML = (slateObject, isNewLine = true) => {
	let value = migrateSlateDataIfNeeded(slateObject);
	if (value) {
		value = htmlSerializer(value);
		if (isNewLine) {
			// Should add new line when needed
			value = value.replaceAll('<span></span>', '<br>');
		}
		// console.log('convertSlateToHTML', value);
		return value;
	}
	return '';
};

export const convertSlateToText = (slateObject) => {
	const value = migrateSlateDataIfNeeded(slateObject);
	if (value) {
		return value
			.map((n) => {
				try {
					return Node.string(n);
				} catch (e) {
					return '';
				}
			})
			.join('\n');
	}
	return '';
};

// Convert testimonials messages to HTML
export const convertTestimonialsMessagesToHTML = (testimonials = []) => {
	// console.log('convertTestimonialsMessagesToHTML', testimonials);
	const newTestimonials = [];
	testimonials.forEach((testimonial) => {
		const html = convertSlateToHTML(testimonial.message, true);
		// const html = convertSlateToText(testimonial.message);
		// testimonial.message = html;
		newTestimonials.push({ ...testimonial, message: html });
	});
	// console.log('convertTestimonialsMessagesToHTML after', newTestimonials);
	return newTestimonials;
};

export const stripTagsFromHTML = (html) => {
	return html.replace(/(<([^>]+)>)/gi, '');
};

export const getResizeImageUrlWidth = (imageUrl, width) => {
	let updatedImageUrl = imageUrl;
	if (!imageUrl.includes('s3.') && !imageUrl.includes(process.env.REACT_APP_CDN_URL)) {
		// s3 not work with w=2000
		updatedImageUrl = `${imageUrl}&w=${width}`;
	}
	return updatedImageUrl;
};

export const getImageUrlFromBackground = (background) => {
	try {
		// url(https://goalsmapper-stage.s3.amazonaws.com/client/156/agent_website/Screenshot_2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAJYDFERWJL5OBUFMA%2F20200916%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Date=20200916T015408Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=74fbc4aaa4c9c061894b123b1b58d1533f1ae3c12804cb5e51911e77f534a8ef) no-repeat center center
		const imageUrl = background.substring(background.indexOf('(') + 1, background.indexOf(')'));
		console.log('getImageUrlFromBackground', imageUrl);
		return imageUrl;
	} catch (e) {
		console.log(e);
	}
	return '';
};

// Set default 2 widgets
export const setDefault2Widgets = () => {
	checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
		console.log('setDefault2Widgets');
		if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
			const widgetsIds = getWidgetsFromHTML();
			generateWidgetsInHTML(widgetsIds);
			// console.log('EditorLeftPanelWebsite generateSections widgets', widgetsIds);
		}
	});
};

export const setInitialDateAndYearReportCover = () => {
	setTimeout(() => {
		const yearDiv = findGrapesJSComponent('.report-year');
		const today = new Date();
		if (yearDiv) {
			const textNode = searchNodeTreeByTextContent(
				yearDiv.getEl(),
				yearDiv.getEl().textContent,
			);
			if (textNode) {
				textNode.innerHTML = today.getFullYear();
			}
		}
		const dateDiv = findGrapesJSComponent('.date');
		if (dateDiv) {
			const options = { year: 'numeric', month: 'long', day: 'numeric' };
			const fullDate = today.toLocaleDateString(undefined, options);
			const textNode = searchNodeTreeByTextContent(
				dateDiv.getEl(),
				dateDiv.getEl().textContent,
			);
			if (textNode) {
				textNode.innerHTML = fullDate;
			}
		}
	}, 10);
};

export const getBase64FileSize = (fullBase64String) => {
	const base64String = fullBase64String.split(',')[1];
	// console.log('base64String', base64String);
	let padding;
	if (base64String.endsWith('==')) padding = 2;
	else if (base64String.endsWith('=')) padding = 1;
	else padding = 0;
	//
	const base64StringLength = base64String.length;
	// console.log('base64StringLength', base64StringLength);
	const inBytes = (base64StringLength / 4) * 3 - padding;
	// console.log('inBytes', inBytes);
	return inBytes;
};

export const clearMaxFileSizeErrorInAssetManager = () => {
	u('.maxFileLimit').remove();
};
export const displayMaxFileSizeErrorInAssetManager = () => {
	//	display error message
	u('.gjs-am-file-uploader').after(`
		<div class="maxFileLimit">Error: Image size is greater than 2MB limit</div>
	`);
};

const getSelectorFromSectionAndPart = (section, headerOrBody) => {
	let selector;
	if (section === 'services') {
		if (headerOrBody === 'header') {
			selector = '#section-services .header';
		} else if (headerOrBody === 'body') {
			selector = '#section-services';
		}
	} else if (section === 'testimonials') {
		if (headerOrBody === 'header') {
			selector = '#section-testimonials .header';
		} else if (headerOrBody === 'body') {
			selector = '#section-testimonials';
		} else if (headerOrBody === 'navButtonColor') {
			selector = '#section-testimonials .gjs-lory-next';
		}
	} else if (section === 'achievements') {
		if (headerOrBody === 'header') {
			selector = '#section-accolades .header';
		} else if (headerOrBody === 'body') {
			selector = '#section-accolades';
		}
	} else if (section === 'main') {
		if (headerOrBody === 'missionText') {
			selector = '#section-main .mission';
		}
	} else if (section === 'about') {
		if (headerOrBody === 'header') {
			selector = '#section-about .header';
		} else if (headerOrBody === 'body') {
			selector = '#section-about';
		}
	} else if (section === 'calculator') {
		if (headerOrBody === 'header') {
			selector = '#section-calculator .header';
		} else if (headerOrBody === 'body') {
			selector = '#section-calculator';
		} else if (headerOrBody === 'buttonTextColor') {
			selector = '#section-calculator .button';
		} else if (headerOrBody === 'buttonBackgroundColor') {
			selector = '#section-calculator .button';
		}
	} else if (section === 'contact') {
		if (headerOrBody === 'header') {
			selector = '#section-contact .header';
		} else if (headerOrBody === 'body') {
			selector = '#section-contact';
		} else if (headerOrBody === 'buttonTextColor') {
			selector = '#section-contact .button';
		} else if (headerOrBody === 'buttonBackgroundColor') {
			selector = '#section-contact .button';
		} else if (headerOrBody === 'socialIcons') {
			selector = '.social a i';
		}
	} else if (section === 'primary-color') {
		selector = '.service-line.gm-primary-color';
	} else if (section === 'videos') {
		selector = '#section-videos .header';
	} else if (section === 'ebook') {
		if (headerOrBody === 'header') {
			selector = '#section-ebook .ebook-title';
		} else if (headerOrBody === 'body') {
			selector = '#section-ebook';
		} else if (headerOrBody === 'buttonTextColor') {
			selector = '#section-ebook .ebook-download-button';
		} else if (headerOrBody === 'buttonBackgroundColor') {
			selector = '#section-ebook .ebook-download-button';
		}
	}
	return selector;
};

export const handleColorChangedForSection = (section, headerOrBody) => (hex) => {
	window.gm_track(`Section color changed`, { section, headerOrBody, hex });

	const selector = getSelectorFromSectionAndPart(section, headerOrBody);
	if (headerOrBody === 'buttonBackgroundColor') {
		setStyleGrapesJSComponents(selector, { background: hex });
	} else {
		console.log('update header color', selector, hex);
		setStyleGrapesJSComponents(selector, { color: hex });
	}
};

// export const getColorHexForSection = (section, headerOrBody, params = {}) => {
// 	const { defaultColorHex = '#000000', isBackground = false } = params;
//
// 	const selector = getSelectorFromSectionAndPart(section, headerOrBody);
// 	let color;
// 	if (isBackground) {
// 		color =
// 			getStyleGrapesJSComponent(selector, 'background') ||
// 			getStyleGrapesJSComponent(selector, 'background-color');
// 	} else {
// 		color = getStyleGrapesJSComponent(selector, 'color');
// 	}
// 	const colorHex = RGBToHex(color || defaultColorHex);
// 	console.log('getColorHexForSection', section, headerOrBody, selector, color, colorHex);
// 	return colorHex;
// };

const getComputedStyle = (element, property) => {
	return window.getComputedStyle
		? window.getComputedStyle(element, null).getPropertyValue(property)
		: element.style[
				property.replace(/-([a-z])/g, function (g) {
					return g[1].toUpperCase();
				})
			];
};

export const getColorHexUsingComputedStyle = (section, headerOrBody, params = {}) => {
	const { defaultColorHex = '#000000', colorProperty = 'color' } = params;

	const selector = getSelectorFromSectionAndPart(section, headerOrBody);
	// console.log('getColorHexForSectionUsingComputedStyle', section, headerOrBody, selector);
	const comp = findGrapesJSComponents(selector)[0];
	if (comp) {
		const element = comp.getEl();
		// console.log('getColorHexForSectionUsingComputedStyle', element);
		const color = getComputedStyle(element, colorProperty);
		// const colorHex = RGBToHex(color || defaultColorHex);
		const colorHex = rgbToHex(color || defaultColorHex);
		// console.log(
		// 	'getColorHexForSectionUsingComputedStyle',
		// 	section,
		// 	headerOrBody,
		// 	selector,
		// 	color,
		// 	colorHex
		// );
		return colorHex;
	}

	return defaultColorHex;
};

// change title in left, menu and in sections
export const changeTitleForLeftMenuSection = (sectionId, inputTitle, source = 'editor') => {
	window.gm_track(`Section Title Changed`, { sectionId, inputTitle, source });
	console.log(`changeTitleForLeftMenuSection`, { sectionId, inputTitle, source });

	let isShownMenu = true;
	if (inputTitle) {
		// change title on left editor
		u(`.each-section-title a[data-section-id="${sectionId}"]`).text(inputTitle);
	} else {
		inputTitle = '';
		isShownMenu = false;
	}
	// change in top menu
	setContentGrapesJSComponent(`a[href="${sectionId}"]`, inputTitle);
	// show/hide top menu nav-bar too
	showHideTopMenu(sectionId, isShownMenu);
	// change section title too
	if (source === 'configurationDialog') {
		setContentGrapesJSComponent(`div${sectionId} .header`, inputTitle);
	}
};

export const handleSaveInEditConfigurationDialog = (values, sectionId) => {
	console.log('handleSaveInEditConfigurationDialog', values, sectionId);

	// now change title in left, menu and in sections
	changeTitleForLeftMenuSection(sectionId, values.title, 'configurationDialog');

	//	do Fitty too
	if (sectionId.includes('-contact')) {
		window.grapesjs.Canvas.getWindow().doFitty();
	}
};

export const setPrimaryColorForTemplate = (template, hex) => {
	if (template === 'template1') {
		window.grapesjs.addComponents(
			`<style>
						.template1 .slash svg path {
								fill: ${hex};
						}
						.template1 .services .service-line, .template1 .accolades .accolade .accolade-wrapper {
						   border-color: ${hex};
						}
						    
    			</style>`,
		);
	} else if (template === 'template2') {
		window.grapesjs.addComponents(
			`<style>		
						.template2 .logo {
							 color: ${hex};						  
						}
						.template2 .services {
						   background: ${hex};			  
						}
						.template2 .testimonials {
							background: ${hex};		
						}
    			</style>`,
		);
	} else if (template === 'template3') {
		window.grapesjs.addComponents(
			`<style>		
						.template3 .logo {
							 color: ${hex};						  
						}
						.template3 .bg-maincolor {
						   background: ${hex};					  
						}      
    			</style>`,
		);
	} else if (template === 'template4') {
		window.grapesjs.addComponents(
			`<style>		
						.template4 .section-navbar .navbar .logo {
							 color: ${hex};							  
						}
						.template4 .contact .section-footer {
								background-color: ${hex};
						}					
    			</style>`,
		);
	} else if (template === 'template5') {
		window.grapesjs.addComponents(
			`<style>							
						.template5 .accolades {
						   background: ${hex};			  
						}
						.template5 .testimonials {
							background: ${hex};		
						}
    			</style>`,
		);
	} else if (template === 'template6') {
		window.grapesjs.addComponents(
			`<style>					
						.template6 .home nav, .template6 .home nav.sticky, .template6 .home nav.sticky .navbar-menu, .template6 .testimonials {
							background-color: ${hex};				
						}
						.template6 .header, .service-title, .accolade-title {
							color: ${hex};				
						}
						.template6 .services .services-wrapper .service:nth-child(odd) {
							border-right-color: ${hex};				
						}
						.template6 .accolades .accolades-wrapper .column:nth-child(odd) {
							border-right-color: ${hex};
						}					
    			</style>`,
		);
	} else if (template === 'template7') {
		window.grapesjs.addComponents(
			`<style>		
						.home .logo {
							 color: ${hex};							  
						}			
    			</style>`,
		);
	} else if (template === 'template8') {
		window.grapesjs.addComponents(
			`<style>		
						.template8 .home .navbar .logo, .template8 .header, .template8 .home .mission {
							 color: ${hex};							  
						}
						.template8 .home .navbar .navbar-end .menu-contact {
								background-color: ${hex};			
						}
    			</style>`,
		);
	} else if (template === 'template9') {
		window.grapesjs.addComponents(
			`<style>		
						.template9 .home .navbar .logo, .template9 .header {
							 color: ${hex};							  
						}
    			</style>`,
		);
	} else if (template === 'template10') {
		window.grapesjs.addComponents(
			`<style>		
						.home .logo, .template10 .header {
							 color: ${hex};							  
						}
    			</style>`,
		);
	}

	// shared rule, use by all templates
	window.grapesjs.addComponents(
		`<style>		
				 .button.is-link, .button.is-link:active, .button.is-link.is-active , .button.is-link:hover, .button.is-link.is-hovered {
						background-color: ${hex};
				 }
				 .${template} .contact .button, .${template} .contact .button.is-link {
						 background-color: ${hex};															  
				 }
				 .navbar-menu a.active {
						color: ${hex};					
				 }
				 .social a i {
						color: ${hex};					
				 }      
				</style>`,
	);
};

export const getPrimaryColorForTemplate = () => {
	const cssComposer = window.grapesjs.CssComposer;
	let selector;
	if (cssComposer) {
		selector = '.social';
		// if (template === 'template1') {
		// 	selector = '.navbar-menu a.active';
		// } else if (template === 'template2') {
		// 	selector = '.template2 .logo';
		// } else if (template === 'template3') {
		// 	selector = '.template3 .logo';
		// } else if (template === 'template4') {
		// 	selector = '.template4 .logo';
		// } else if (template === 'template5') {
		// 	selector = 'useButtonBackground';
		// } else if (template === 'template6') {
		// 	selector = '.home .logo';
		// } else if (template === 'template7') {
		// 	selector = '.home .logo';
		// } else if (template === 'template8') {
		// 	selector = '.home .logo';
		// } else if (template === 'template9') {
		// 	selector = '.home .logo';
		// } else if (template === 'template10') {
		// 	selector = '.home .logo';
		// }
	}

	if (selector) {
		let primaryColorRule;
		if (selector === 'useButtonBackground') {
			primaryColorRule =
				cssComposer.getRule('.contact button')?.attributes?.style['background-color']; // color: "rgb(183, 28, 28)"
		} else {
			primaryColorRule = cssComposer.getRule(selector)?.attributes?.style?.color; // color: "rgb(183, 28, 28)"
		}
		if (primaryColorRule) {
			const primaryColorHex = rgbToHex(primaryColorRule);
			console.log('getPrimaryColorForTemplate', primaryColorRule, primaryColorHex);
			return primaryColorHex;
		}
	}

	return '';
};

export const deconstructErrorMessage = (error) => {
	if (!error) {
		return {};
	}
	const errorCode = error.code;
	if (errorCode === 401) {
		return {
			title: 'SORRY :(',
			errorCode,
			message: error.msg,
			imageUrl: 'https://static.goalsmapper.com/public/platform/empty_state/error_page.png',
		};
	}

	return {};
};

export const extractVideoIdFromURL = (urlString, stringsToTry) => {
	let videoId = null;
	stringsToTry.forEach((matchString) => {
		const indexOfMatchedString = urlString.lastIndexOf(matchString);
		if (!videoId && indexOfMatchedString >= 0) {
			videoId = urlString.substring(indexOfMatchedString + 1).trim();
		}
	});

	return videoId;
};

export const getVideoUrlForVideosSection = (videoContainerId) => {
	console.log('getVideoUrlForVideosSection', videoContainerId);
	const elem = getElementFromIframe('.gjs-frame', `${videoContainerId} iframe[src]`);
	if (elem) {
		// 	https://www.youtube.com/embed/aHAMkPEyZgM
		//  https://player.vimeo.com/video/290833426
		const src = elem.getAttribute('src');
		console.log('getVideoUrlForVideosSection', src);

		if (src.includes('youtube.com') || src.includes('youtube_relay')) {
			const videoId = extractVideoIdFromURL(src, ['=', '/']);
			return {
				videoYoutubeUrl: `https://www.youtube.com/watch?v=${videoId}`,
				videoVimeoUrl: '',
			};
		}
		if (src.includes('vimeo.com')) {
			const videoId = extractVideoIdFromURL(src, ['/']);
			return {
				videoYoutubeUrl: '',
				videoVimeoUrl: `https://vimeo.com/${videoId}`,
			};
		}
	}
	return {};
};

export const getTemplateSectionConfig = (templateId, section) => {
	const templateConfig = TemplateConfigs[templateId];
	if (templateConfig) {
		let _section = section;
		if (section === '#section-main-hero') {
			_section = 'main';
		}
		return templateConfig[_section];
	}
	return {};
};

export const getTemplateConfigs = (templateId) => {
	return TemplateConfigs[templateId] || {};
};

export const setStorageManagerForceReset = (forceReset = false) => {
	window.grapesjs.StorageManager.getConfig().headers['X-Template-Force-Reset'] = forceReset;
};

export const makeContactInfoReadOnly = () => {
	console.log('makeContactInfoReadOnly ');
	if (window.currentTemplate === 'template3') {
		setAllChildComponentsReadOnly('.email-phone');
	} else {
		setAllChildComponentsReadOnly('.info');
		setAllChildComponentsReadOnly('.below-header');
	}
};

const applyExtraProfileToEditor = (extraProfile) => {
	if (extraProfile.story) {
		applyTextIntoSelector('.introduction', extraProfile.story);
	}
	if (extraProfile.services?.length > 0) {
		const cleanServices = extraProfile.services.filter((s) => s.title || s.description);
		const serviceRows = findGrapesJSComponents('#section-services .service');
		const applySize = Math.min(cleanServices.length, serviceRows.length);
		for (let i = 0; i < applySize; i += 1) {
			const serviceRow = serviceRows[i];
			const serviceData = cleanServices[i];
			applyTextIntoSelector('.service-title', serviceData.title, serviceRow);
			applyTextIntoSelector('.service-description', serviceData.description, serviceRow);
		}
	}
	if (extraProfile.accolades?.length > 0) {
		const cleanData = extraProfile.accolades.filter((s) => s.title || s.description);
		const rowComponents = findGrapesJSComponents('#section-accolades .accolade');
		const applySize = Math.min(cleanData.length, rowComponents.length);
		for (let i = 0; i < applySize; i += 1) {
			const rowComponent = rowComponents[i];
			const rowData = cleanData[i];
			let accoladeTitleSelector = '.accolade-title';
			let accoladeTitleDescription = '.accolade-description';
			if (window.currentTemplate === 'template3') {
				accoladeTitleSelector = '.accolade-description .company-name';
				accoladeTitleDescription = '.accolade-description .description';
			}
			applyTextIntoSelector(accoladeTitleSelector, rowData.title, rowComponent);
			applyTextIntoSelector(accoladeTitleDescription, rowData.description, rowComponent);
		}
	}
};

export const applyExtraDataToEditorRight = (adviserInfo) => {
	console.log('applyExtraDataToEditorRight', { ...adviserInfo });
	if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		const { contactForm, extraProfile = {} } = adviserInfo;
		setContactFormToTemplate(contactForm);
		// Set default 2 widgets to right again
		setDefault2Widgets();
		applyExtraProfileToEditor(extraProfile);
		makeContactInfoReadOnly();
		setAllComponentsReadOnlyButTextAndImage();
	}
};

const doOneRoundRemoveAddClasses = (removeClass, addClass) => {
	removeAddClassElement('#grapesjs-react-editor', removeClass, addClass);

	// zendesk
	removeAddClassElement('iframe#launcher', removeClass, addClass);
	removeAddClassElement('iframe#webWidget', removeClass, addClass);
};

export const addDrawerOpenCloseClasses = (drawerOpen) => {
	if (!drawerOpen) {
		doOneRoundRemoveAddClasses('drawer-closed', 'drawer-opened');
	} else {
		doOneRoundRemoveAddClasses('drawer-opened', 'drawer-closed');
	}
};

export const addSeoSubformOpenCloseClasses = (seoSubformOpen) => {
	if (seoSubformOpen) {
		doOneRoundRemoveAddClasses('seosubform-closed', 'seosubform-opened');
	} else {
		doOneRoundRemoveAddClasses('seosubform-opened', 'seosubform-closed');
	}
};

export const setDataGMUserTypeToHTML = () => {
	// set user type start-up or suit-up to html
	// console.log('runInComponentUpdate', adviserInfo);
	const { is_suitup, is_scaleup } = window.adviserData;
	let className = 'start-up';
	if (is_suitup) {
		className = 'suit-up';
	} else if (is_scaleup) {
		className = 'scale-up';
	}
	setAttributeGrapesJSComponent(`#wrapper > div`, { 'data-gm-user-type': className });
};

export const getWhatsappUniversalLink = (phone) => {
	if (phone.startsWith('https://wa.me')) return phone;
	const formattedPhone = phone
		.replace(/-/g, '')
		.replace(/\+/g, '')
		.replace(/\(/g, '')
		.replace(/\)/g, '')
		.replace(/^0+/, '')
		.replace(/ /g, '');
	return `https://wa.me/${formattedPhone}`;
};

export const getTelegramUniversalLink = (telegramId) => {
	if (telegramId.startsWith('https://telegram.me')) return telegramId;
	return `https://telegram.me/${telegramId}`;
};

export const getSocialMediaLinks = (link) => {
	if (!link.startsWith('https://')) {
		link = `https://${link}`;
	}
	return link;
};

export const convertPxToRelative = (value, factor, unit) => {
	return `${value * factor}${unit}`;
};

export const convertFontSizeToRemEbookIntro = (component) => {
	if (!component.is('text')) return;
	let textContent = component.get('content');

	for (let number = 8; number < 80; number += 1) {
		const rem = number * 0.0898611425188285;
		textContent = textContent.replaceAll(`font-size:${number}px`, `font-size:${rem}rem`);
	}
	// console.log('convertFontSizeToRemEbookIntro textContent after', textContent);
	component.set('content', textContent);
	// 	<span style="font-size:9px">Lisa Tan joined the financia</span><br />
};

export const getDefaultContactDisclaimer = ({
	contact_disclaimer,
	adviserData = window.adviserData,
}) => {
	const { first_name: firstName, last_name: lastName } = adviserData;
	if (!contact_disclaimer) {
		const contact_disclaimer_json = JSON.stringify(CONTACT_DISCLAIMER_DEFAULT());
		contact_disclaimer = JSON.parse(
			contact_disclaimer_json.replaceAll('FIRSTNAMELASTNAME', `${firstName} ${lastName}`),
		);
	}
	return contact_disclaimer;
};

export const getDefaultWidgetDisclaimer = ({
	widget_disclaimer,
	adviserData = window.adviserData,
}) => {
	const { first_name: firstName, last_name: lastName } = adviserData;
	if (!widget_disclaimer) {
		const widget_disclaimer_json = JSON.stringify(WIDGET_DISCLAIMER_DEFAULT());
		widget_disclaimer = JSON.parse(
			widget_disclaimer_json.replaceAll('FIRSTNAMELASTNAME', `${firstName} ${lastName}`),
		);
	}
	return widget_disclaimer;
};

export const setContactDisclaimerGrapesJS = (contact_disclaimer) => {
	const contactDisclaimerHTML = convertSlateToHTML(contact_disclaimer, false);
	const contactDisclaimerHTMLStrip = stripTagsFromHTML2(contactDisclaimerHTML).trim();
	// console.log('setContactDisclaimerGrapesJS', { contactDisclaimerHTML });
	const prettyCheckBoxes = findGrapesJSComponents('.pretty');
	if (!contactDisclaimerHTMLStrip) {
		// console.log('setContactDisclaimerGrapesJS NOT');
		hideGrapesJSComponents(prettyCheckBoxes);
	} else {
		showGrapesJSComponents(prettyCheckBoxes);
		setContentGrapesJSComponent('.pretty label', contactDisclaimerHTML);
	}
};

export const addWidgetDisclaimerSlateHtmlText = (values) => {
	console.log('addWidgetDisclaimerSlateText', values);
	const { widget_disclaimer } = values;
	if (widget_disclaimer) {
		const widgetDisclaimerHTML = convertSlateToHTML(widget_disclaimer);
		const widgetDisclaimerText = stripTagsFromHTML2(widgetDisclaimerHTML).trim();
		return {
			...values,
			widget_disclaimer_html: widgetDisclaimerHTML,
			widget_disclaimer_text: widgetDisclaimerText,
		};
	}
	return values;
};

const unwrapAll = (doc, selector) => {
	const unwrap = (doc, selector) => {
		const element = doc.querySelector(selector);
		if (element) {
			element.outerHTML = element.innerHTML;
		}
		return !!element;
	};

	while (true) {
		const result = unwrap(doc, selector);
		if (!result) break;
	}
};

export const removeTagsFromString = (str, tags) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(str, 'text/html');
	tags.forEach((tag) => {
		unwrapAll(doc, tag);
	});
	const result = doc.body.innerHTML;
	return result;
};
